import React, { Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router";
import { ConfigManagement } from "../../components/Pages/ConfigManagement";
import ConfigurationEditor from "../../components/Pages/ConfigManagement/configurationEditor";
import ContentCuration from "../../components/Pages/ContentCuration";
import ContentCurationList from "../../components/Pages/ContentCuration/ContentCurationList";
import ContentCurationVersions from "../../components/Pages/ContentCuration/ContentCurationVersions";
import ErrorBoundary from "../../components/Pages/ErrorBoundary";
import IngestionUpload from "../../components/Pages/Ingestion";
import PVCPackageLogs from "../../components/Pages/Ingestion/pvcpackagelogs";
import LandingPage from "../../components/Pages/LandingPage";
import { LoadingPage } from "../../components/Pages/LoadingPage";
import { Localization } from "../../components/Pages/Localization";
import "./index.css";
import ChangeLog from "../../components/Pages/ContentCuration/ChangeLog";
import GenreManagement from "../../components/Pages/GenreManagement";
import MetadataManagement from "../../components/Pages/MetadataManagement";
const AvailsPlusManagement = React.lazy(
    () => import("../../components/Pages/AvailsPlusManagement")
);
import PromoVideoManagement from "../../components/Pages/ContentCuration/PromoVideoManagement";
import PromoVideoForm from "../../components/Pages/ContentCuration/PromoVideoManagement/PromoVideoForm";
import YouMayAlsoLikeManagement from "../../components/Pages/ContentCuration/YouMayAlsoLikeManagement";
import UserManagement from "../../components/Pages/UserManagement/index";
import BoostSearch from "../../components/Pages/ContentCuration/BoostSearch";
import ViewVersion from "../../components/Pages/ConfigManagement/viewVersion";
import OpenSearchSync from "../../components/Pages/ContentCuration/OpenSearchSync";
import DSARDashboard from "../../components/Pages/DSAR";

const AppRouter = () => {
    return (
        <div>
            <main className="appwide-container">
                <ErrorBoundary>
                    <Suspense fallback={<LoadingPage />}>
                        <Routes>
                            <Route
                                path="/"
                                element={
                                    <LandingPage>
                                        <ConfigManagement />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/json-viewer"
                                element={
                                    <LandingPage>
                                        <ViewVersion />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/config"
                                element={
                                    <LandingPage>
                                        <ConfigManagement />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/localization"
                                element={
                                    <LandingPage>
                                        <Localization />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/localization/save-config"
                                element={
                                    <LandingPage>
                                        <ConfigurationEditor />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/localization/edit-config"
                                element={
                                    <LandingPage>
                                        <ConfigurationEditor />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/ingestion"
                                element={
                                    <LandingPage>
                                        <IngestionUpload />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/pvc-package-logs"
                                element={
                                    <LandingPage>
                                        <PVCPackageLogs />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/vendor-transfer-logs"
                                element={
                                    <LandingPage>
                                        <PVCPackageLogs />
                                    </LandingPage>
                                }
                            />

                            <Route
                                path="/content-curation"
                                element={
                                    <LandingPage>
                                        <ContentCuration />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/content-curation-versions"
                                element={
                                    <LandingPage>
                                        <ContentCurationVersions />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/change-log"
                                element={
                                    <LandingPage>
                                        <ChangeLog />
                                    </LandingPage>
                                }
                            />

                            <Route
                                path="/content-curation-list"
                                element={
                                    <LandingPage>
                                        <ContentCurationList />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/genre-management"
                                element={
                                    <LandingPage>
                                        <GenreManagement />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/avails"
                                element={
                                    <LandingPage>
                                        <MetadataManagement />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/avails-plus"
                                element={
                                    <LandingPage>
                                        <AvailsPlusManagement />
                                    </LandingPage>
                                }
                            />

                            {/* Promo video management */}
                            <Route
                                path="/promo-video-management"
                                element={
                                    <LandingPage>
                                        <PromoVideoManagement />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/promo-video-management/:id"
                                element={
                                    <LandingPage>
                                        <PromoVideoForm />
                                    </LandingPage>
                                }
                            />

                            {/* You May Also Like Management */}
                            <Route
                                path="/ymal-management"
                                element={
                                    <LandingPage>
                                        <YouMayAlsoLikeManagement />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/user-management"
                                element={
                                    <LandingPage>
                                        <UserManagement />
                                    </LandingPage>
                                }
                            />

                            <Route
                                path="/boost-search"
                                element={
                                    <LandingPage>
                                        <BoostSearch />
                                    </LandingPage>
                                }
                            />

                            <Route
                                path="/open-search-sync"
                                element={
                                    <LandingPage>
                                        <OpenSearchSync />
                                    </LandingPage>
                                }
                            />
                            <Route
                                path="/dsar"
                                element={
                                    <LandingPage>
                                        <DSARDashboard />
                                    </LandingPage>
                                }
                            />
                        </Routes>
                    </Suspense>
                </ErrorBoundary>
            </main>
        </div>
    );
};

export default AppRouter;
